import FormValidationClass from "../common/FormValidationClass";
import FormValidationMessagesClass from "../common/FormValidationMessagesClass";
import {
    fetchRequestSend, setCookieHelper
} from "../../helpers/common-helpers";
import PreloaderClass from "../common/PreloaderClass";
import l10n from '../../lang/locallang';

/**
 * Class representing the login functionality.
 */
export default class SignUpFormClass {
    /**
     * Creates an instance of LoginClass.
     */
    constructor() {
        this.initializeEventListeners();
    }

    /**
     * Initializes event listeners for the login form.
     */
    initializeEventListeners() {
        // login form
        const signUpForm = document.getElementById('free_signup-form');
        if (signUpForm) {
            signUpForm.addEventListener('submit', e => this.handleFormSubmit(e, signUpForm));
        }
    }

    /**
     * Handles the form submission.
     * @param {Event} e - The submit event.
     * @param {HTMLFormElement} form - The form being submitted.
     */
    handleFormSubmit(e, form) {
        e.preventDefault();
        PreloaderClass.forPopup(form.id); // run PreloaderClass
        if (form.id === 'free_signup-form') {
            this.signUp(form);
        }
    }

    /**
     * Handles the login process.
     * @param {HTMLFormElement} form - The form being processed.
     */
    signUp(form) {
        const isFormValid = this.validateForm(form);
        if (isFormValid) {
            new FormValidationMessagesClass().hideErrorForForm(form.id);
            const formData = new FormData(form);
            if(typeof trialRegistrationURL === 'undefined'){
                return false;
            }
            this.sendLoginRequest(trialRegistrationURL, formData)
                .then(response => {
                    PreloaderClass.stop(); // stop PreloaderClass
                    if (!response.status) {
                        response.fields.forEach(field => {
                            let element_id = form.querySelector(`input[name="${field}"]`).id;
                            console.log(response.errors[field])
                            new FormValidationMessagesClass().showErrorForField(element_id, response.errors[field]);
                        });
                    } else {
                        console.log(response)
                        // remove all error messages
                        form.querySelectorAll('.error-message-text').forEach(item => item.remove());
                        // set cookie to _signup_email
                        setCookieHelper('_signup_email', formData.get('email'), { expires: 3600, path: '/' });
                        setCookieHelper('_signup_password', formData.get('password'), { expires: 3000, path: '/' });
                        setCookieHelper('_signup_name', formData.get('customer_name'), { expires: 3600, path: '/' });
                        // if(response.hs.user_contact.company_id){
                        //     setCookieHelper('_signup_company', response.hs.user_contact.company_id, { expires: 3600, path: '/' });
                        // }
                        window.location.href = response.redirect_url;
                    }
                });
        } else {
            PreloaderClass.stop(); // stop PreloaderClass
        }
    }


    /**
     * Validates the login form.
     * @returns {boolean} - True if the form is valid, false otherwise.
     */
    validateForm(form) {
        const { useWorkEmail } = l10n.forms;
        const formValidator = new FormValidationClass(form.id).init();
        if(formValidator){
            // check email is valid
            const email = form.querySelector('input[name="email"]');
            // if email is fit any on this array, then show error
            const banned_domains = [
                'bell.net',
                'email.com',
                'mac.com',
                'mail.com',
                'me.com',
                'aol.com',
                'bellsouth.com',
                'charter.net',
                'comcast.net',
                'earthlink.net',
                'gmx.com',
                'hotmail.com',
                'icloud.com',
                'live.com',
                'msn.com',
                'netzero.net',
                'outlook.com',
                'protonmail.com',
                'sbcglobal.net',
                'telus.net',
                'tutanota.com',
                'yahoo.com',
                'ymail.com',
                //'mailinator.com',
                'guerrillamail.com',
                '10minutemail.com',
                'dispostable.com',
                'yopmail.com',
                'throwawaymail.com',
                'tempmail.net',
                'getnada.com',
                'sharklasers.com',
                'temp-mail.org'
            ];
            const email_domain = email.value.split('@')[1];
            if(banned_domains.includes(email_domain)){
                // show error
                new FormValidationMessagesClass().showErrorForField('free_signup-email', `${useWorkEmail}.`);
                // stop PreloaderClass
                PreloaderClass.stop();
                return false;
            } else {
                // hide error
                new FormValidationMessagesClass().hideErrorForField('free_signup-email');
                return true;
            }
        }
    }


    /**
     * Sends a login request to the server.
     * @param {string} action - The URL to send the request to.
     * @param {Object} data - The data to send in the request.
     * @returns {Promise<Object>} - The server response.
     */
    sendLoginRequest( url, data) {
        console.log(data)
        return fetchRequestSend(url, 'POST', data);
    }
}
